export default __webpack_public_path__ + "static/mstile-310x310-26d1239a293f93ddd22a7b2b88381e72.png";